<div class="card" [routerLink]="'launches/' + launch.link" *ngIf="launch" tabindex="0">
  <div class="card-content">
    <img [src]="photoUrl" loading="lazy" />
    <div>
      <span class="title">{{launch.title}}</span>
      <span class="countdown">
        <launch-time [missionId]="launch.link" type="widget" justify="left"></launch-time>
      </span>
    </div>
  </div>

  <arrow-svg class="button" height="16" width="16"></arrow-svg>
</div>